import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import { ManualAllotmentsComponent } from './manual-allotments/manual-allotments.component';
import {RoundSettingsComponent} from './round-settings/round-settings.component';

@NgModule({
    imports: [ CommonModule, NgbModalModule, FormsModule],
    declarations: [ManualAllotmentsComponent, RoundSettingsComponent]
})
export class AllotmentsModule { }
